import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { HpRespModuleContainerOld } from '../HpRespModuleContainerOld/HpRespModuleContainerOld';
import { HpRespEditorialModuleItemOld } from './HpRespEditorialModuleItemOld';
import { trackEditorialImpressions, trackEditorialClick } from './helpers/EditorialTrackingOld';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

class HpRespEditorialModuleOldComponent extends Component {
    items = get(this.props, 'homepage.editorialModule.items');

    handleInitialDisplay = ({ inViewport }) => {
        if (this.items && inViewport) {
            trackEditorialImpressions(this.items);
        }
    };

    render() {
        if (!this.items) {
            return null;
        }

        return (
            <HpRespModuleContainerOld addTopGap>
                <SharedInViewport stopWhenInViewport onInViewportChange={this.handleInitialDisplay}>
                    <div className="rowFlex" data-tn="editorial-wrapper">
                        {this.items.map((item, index) => (
                            <HpRespEditorialModuleItemOld
                                key={item.cmsId}
                                item={item}
                                onClick={() => trackEditorialClick(item, index)}
                            />
                        ))}
                    </div>
                </SharedInViewport>
            </HpRespModuleContainerOld>
        );
    }
}

HpRespEditorialModuleOldComponent.propTypes = {
    homepage: PropTypes.object.isRequired,
};

export const HpRespEditorialModuleOld = createFragmentContainer(HpRespEditorialModuleOldComponent, {
    homepage: graphql`
        fragment HpRespEditorialModuleOld_homepage on Homepage {
            editorialModule: module(type: "editorial") {
                ... on EditorialModule {
                    items {
                        cmsId
                        cta
                        description
                        link
                        imageUrl
                    }
                }
            }
        }
    `,
});
